import { createContext } from "react";

export interface SandboxPanelState {
    hasControls: boolean;
    isPanelOpen: boolean;
    togglePanel: () => void;
}

export const SandboxPanelContext = createContext<SandboxPanelState>({
    hasControls: false,
    isPanelOpen: false,
    togglePanel: () => undefined,
});
